/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordDeviceMatchV1ResponseDataSchema = z.object({
  matched: z.boolean(),
});

export type IRecordDeviceMatchV1ResponseData = z.infer<
  typeof recordDeviceMatchV1ResponseDataSchema
>;

export const recordDeviceMatchV1ResponseSchema = createApiResponseSchema(
  recordDeviceMatchV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordDeviceMatchV1ResponseData>>;

export type IRecordDeviceMatchV1Response = IAPI<IRecordDeviceMatchV1ResponseData>;
